import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpotlightProjects = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-briefcase w-5 h-5 text-[#16A34A]",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" }), /* @__PURE__ */ _jsx("rect", {
		width: 20,
		height: 14,
		x: 2,
		y: 6,
		rx: 2
	})]
});
export default SvgSpotlightProjects;
